import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import useCanViewPractices from 'lib/hooks/useCanViewPractices';

import Spinner from 'components/shared/spinner/spinner';
import { showAlert } from 'components/shared/Alert/Alert';
import { permissions as permissionsState } from 'components/state';

export const NO_PRACTICE_ACCESS = 'You do not have the necessary permissions';

const PracticesAccess = ({ children }) => {
  const permissions = useRecoilValue(permissionsState);
  const canViewPractices = useCanViewPractices();
  const isBlocked = !!permissions?.loaded && !canViewPractices;

  useEffect(() => {
    if (isBlocked) showAlert({ title: NO_PRACTICE_ACCESS, color: 'danger' });
  }, [isBlocked]);

  if (!permissions?.loaded) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (isBlocked) return <Navigate to="/admin" replace />;

  return children;
};

export default PracticesAccess;
